<template>
  <v-dialog v-model="displayForm" persistent max-width="1240px">
    <v-form ref="form" v-model="valid" lazy-validation v-if="displayForm">
      <v-card>
        <v-card-title>
          {{ model.id ? 'Update Putter' : 'Add Putter' }}
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="msg"
            type="error"
            dismissible
            transition="scale-transition"
            v-for="msg in message"
            :key="msg"
          >{{ msg }}</v-alert>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="model.headOnly"
                label="Head Only"
                :false-value="0"
                :true-value="1"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="model.stamping"
                label="Stamping"
                :false-value="0"
                :true-value="1"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="model.paintfill"
                label="Paintfill"
                :false-value="0"
                :true-value="1"
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="model.quantity" label="Quantity" :rules="mandatoryRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <product-selection
                  v-model="model.headProductId"
                  label="Club Head"
                  :dominantHand="dominantHand"
                  :type="['PUTTER']"
                  :catalogId="catalogId"
                  :rules="mandatoryRules"
                  :currency="currency"
              ></product-selection>
            </v-col>
            <v-col>
              <v-text-field
                label="Loft"
                v-model="model.headLoft"
                :rules="[rules.notHeadOnlyRequired]"
                :disabled="!model.headProductId"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="model.headLie"
                label="Lie"
                :rules="[rules.notHeadOnlyRequired]"
                :disabled="!model.headProductId"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="model.stamping || model.paintfill">
            <v-col v-if="model.stamping">
              <v-text-field
                v-model="model.headStamp"
                label="Stamp"
                :disabled="!model.headProductId"
                dense
                :hide-details="false"
              ></v-text-field>
            </v-col>
            <v-col v-if="model.paintfill">
              <v-text-field
                v-model="model.headPaintfill"
                label="Paintfill"
                :disabled="!model.headProductId"
                dense
                :hide-details="false"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!model.headOnly">
            <v-col cols="6">
              <product-selection
                  v-model="model.shaftProductId"
                  label="Shaft"
                  :type="['PUTTER SHAFT','SHAFT']"
                  :catalogId="catalogId"
                  :rules="[rules.notHeadOnlyRequired]"
                  :currency="currency"
              ></product-selection>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="model.shaftLength"
                label="Length"
                :rules="mandatoryRules"
                :disabled="!model.shaftProductId"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-combobox
                label="SW"
                v-model="model.shaftSW"
                :items="[
                  'A0','A1','A2','A3','A4','A5','A6','A7','A8','A9',
                  'B0','B1','B2','B3','B4','B5','B6','B7','B8','B9',
                  'C0','C1','C2','C3','C4','C5','C6','C7','C8','C9',
                  'D0','D1','D2','D3','D4','D5','D6','D7','D8','D9',
                  'E0','E1','E2','E3','E4','E5','E6','E7','E8','E9',
                  'F0','F1','F2','F3','F4','F5','F6','F7','F8','F9',
                ]"
                :rules="[rules.notHeadOnlyRequired]"
                :disabled="!model.shaftProductId"
              />
            </v-col>
          </v-row>
          <v-row v-if="!model.headOnly">
            <v-col cols="6">
              <product-selection
                  v-model="model.gripProductId"
                  label="Grip"
                  :type="['PUTTER GRIP','GRIP']"
                  :catalogId="catalogId"
                  :rules="[rules.notHeadOnlyRequired]"
                  :currency="currency"
              ></product-selection>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="add()" v-if="!model.id">Add</v-btn>
          <v-btn color="blue darken-1" text @click="update()" v-else>Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ProductSelection from "@components/forms/search/ProductSelection.vue"


const defaultModel = {
  sst: 0,
  stamping: 0,
  paintfill: 0,
  quantity: 1,
  headProductId: null,
  headLoft: null,
  headLie: null,
  headStamp: null,
  shaftProductId: null,
  shaftLength: null,
  shaftCpm: null,
  shaftSW: null,
  shaftPaintfill: null,
  gripProductId: null,
  gripExtraWraps: null,
  gripLogo: 'up'
}

export default {
  components: {
    ProductSelection
  },
  props: {
    prescriptionId: {
      type: Number,
      required: true
    },
    dominantHand: {
      type: String,
      default: () => ''
    },
    catalogId: {
      type: Number,
      required: true
    },
    currency:{
      type: String,
      default: () => 'EUR'
    }
  },
  data: () =>({
    loading: false,
    model: {},
    logo: [
      { text: "UP", value: "up" },
      { text: "DOWN", value: "dw" }
    ],
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    valid: null,
    message: null,
    displayForm: false
  }),
  computed: {
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory.",
        notHeadOnlyRequired: value => {
          if (this.model.headOnly) return true;
          return !!value || "This field is mandatory.";
        }
      };
    }
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("prescriptionPutter/add", {
            id: this.prescriptionId,
            model: this.model
          })
          .then(() => {
            this.cancel();
            this.$emit("update");
          })
          .catch((result) => {
            this.message = [];
            for (const field in result.message) {
              if ({}.propertyIsEnumerable.call(result.message, field)) {
                const msg = result.message[field];
                this.message.push(msg[0]);
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("prescriptionPutter/update", {
            prescriptionId: this.prescriptionId,
            id: this.model.id,
            model: this.model
          })
          .then(() => {
            this.cancel();
            this.$emit("update");
          })
          .catch((result) => {
            this.message = [];
            for (const field in result.message) {
              if ({}.propertyIsEnumerable.call(result.message, field)) {
                const msg = result.message[field];
                this.message.push(msg[0]);
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    cancel() {
      this.resetForm();
      this.displayForm = false
    },
    resetForm() {
      Object.assign(this.model, defaultModel)
      this.$refs.form.reset();
    },
    open (item) {
      const tmp = {}
      if(item) {
        Object.assign(tmp, item)
      }else{
        Object.assign(tmp, defaultModel)
      }
      this.$set(this, 'model', tmp)
      this.displayForm = true
    }
  }
};
</script>

<style lang="less" scoped></style>
